<template>
  <div  class="by_law-item-show">
    <div 
      v-if="!isEditShow"
      class="by_law-item"
    > 
      <v-checkbox
        :label="itemByLaw.transName"
        :input-value="isChecked(itemByLaw) "
        @change="changeByLaw(itemByLaw)"
        :checked="true"
      ></v-checkbox>

      <span 
        @click="changeShowEdit"
        class="pro-icon-pencil by_law-item-pencil" 
      />

      <span
        class="by_law-item-remove"
        @click="removeByLaw(itemByLaw.id)"
      >
        <i class="fa fa-trash" aria-hidden="true"></i>
      </span>
      <!-- <div
         @click="clearRadio" class="clear"
         v-if="byLawSelected == itemByLaw.id"
      >
        Отменить выбор
      </div> -->
    </div>
    <div v-else>
      <InlineEditByLaw 
        :by-law="itemByLaw"
        @cancel="changeShowEdit"
        @save="saveByLaw"
      />
    </div>
  </div>
</template>
<script>
import InlineEditByLaw from '@/components/law/InlineEditByLaw.vue'
import LAW from '@/model/law'

export default {
  name: 'LawNormFormByLawsItem',
  components: {
    InlineEditByLaw
  },
  props: {
    item: {
      type: Object,
      requied: true
    },
    byLaws: {
      type: Array,
      default: () => { return [] }
    }
  },

  data () {
    return {
      byLawSelectedData: '',
      isEditShow: false
    }
  },

  created () {
    this.itemByLaw = this.item
  },

  methods: {
    isChecked (itemByLaw) {
      return this.byLaws.includes(itemByLaw.id)
    },

    changeByLaw(byLaw) {
      this.$emit('change', byLaw)
    },
    removeByLaw(id) {
      LAW.removeByLaw(id).then((response) => {
        this.$emit('remove', id)
      })
    },
    clearRadio () {
      this.$emit('clear')
    },

    changeShowEdit () {
      this.isEditShow = !this.isEditShow
    },

    saveByLaw (byLaw) {
      LAW.editByLaw(byLaw).then((response) => {
        this.itemByLaw = {...this.item, ...response.data}
        console.log(itemByLaw)
      }).catch((error) => {})

      this.isEditShow = false
    }
  }
}
</script>
<style lang="scss" scoped>
  .by-law-item {

    &-show {
      display: flex;
      flex-direction: column;
    }
  }

  .clear {
      background: #7b7b7b;
      padding: 0px 10px;
      cursor: pointer;
      margin-left: 10px;
      color: #fff;
  }
</style>